
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.975 22H2.034a4.106 4.106 0 00-.279-.074 2.123 2.123 0 01-1.75-1.934q-.012-4.865 0-9.731a2.121 2.121 0 011.97-1.967c.387-.054.782-.04 1.192-.06V8c0-.866-.008-1.733 0-2.6a5.62 5.62 0 014.3-5.1c.48-.134.991-.2 1.487-.3h1.092l.387.06c3.2.457 5.4 2.72 5.4 5.534v2.659c.31 0 .581-.007.852 0a2.215 2.215 0 012.307 2.008c.015 3.244.008 6.487 0 9.731a2.084 2.084 0 01-1.556 1.887c-.161.04-.311.074-.461.121zM5.294 8.227h8.393v-3.21a1.276 1.276 0 00-.031-.168c-.348-1.914-2.563-3.3-4.762-2.988a3.846 3.846 0 00-3.608 3.673c-.008.833 0 1.659 0 2.491a.893.893 0 00.008.202zm3.151 8.233v.363c0 .215-.008.43.008.645a1 1 0 001.038.86.986.986 0 001.053-.846c.023-.638.015-1.276.008-1.914a.382.382 0 01.209-.369 1.657 1.657 0 00.635-2.263 2.2 2.2 0 00-2.47-.954 1.862 1.862 0 00-1.487 1.41 1.625 1.625 0 00.821 1.813.369.369 0 01.2.356c-.022.301-.015.597-.015.899z","fill":"#3a3a3a"}})])
          )
        }
      }
    